import { render, staticRenderFns } from "./NumbersSettings.vue?vue&type=template&id=5a716f8c&scoped=true&"
import script from "./NumbersSettings.vue?vue&type=script&lang=js&"
export * from "./NumbersSettings.vue?vue&type=script&lang=js&"
import style0 from "./NumbersSettings.vue?vue&type=style&index=0&id=5a716f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a716f8c",
  null
  
)

export default component.exports